import React, { useCallback, useContext,  useState } from 'react'
import { Stack } from '@mui/material';
import { COLOR_MAP } from '../../../../constants/ColorNames';
import AbortIcon from '../../../../constants/icons/AbortIcon';
import styled from '@emotion/styled';
import { useGetAbortCampaignMutation } from '../../../../redux/services/folderName';
import { ToastContext } from '../../../../utils/context/toastContext';
import { RotatingLines } from 'react-loader-spinner';
import BasicModal from '../../../../common/components/Modal';
import { Button } from '@foundit/ui-library';

type AbortCampaignPropsType = {
  campaignId: string;
  campaignName: string;
  status: string;
  rawStatus: string;
}


export const AbortCampaign = (props: AbortCampaignPropsType) => {
  const [triggerAbort, { data, isLoading }] = useGetAbortCampaignMutation();
  const { campaignId,  campaignName, rawStatus } = props;
  const { setToastValue } = useContext(ToastContext);
  const [openAbortModal, setOpenAbortModal] = useState<boolean>(false);
  const selectedColor =  "#E03923"

  const showAbort = ['paused', 'scheduled', 'auto_paused'].includes(rawStatus?.toLowerCase());


  const handleAbortCampaign = React.useCallback(() => {
    triggerAbort(campaignId)
      .unwrap()
      .then((res) => {
        if (res) {
          const message = `Campaign "${campaignName}" aborted successfully`
          setToastValue({
            isToastShown: true,
            toastMessage: message,
            toastKey: 'campaign-abort-success',
            toastSeverity: 'success'
          })
        }
      })
      .catch((err) => {
        const message = err.data?.message ? err.data.message  : 'Error while aborting the campaign';
        setToastValue({
          isToastShown: true,
          toastMessage: message,
          toastKey: 'campaign-abort-error',
          toastSeverity: 'error'
        })
      })

  }, [campaignId, setToastValue, triggerAbort])

  const handleAction = () => {
    setOpenAbortModal(true);
  }

  if (data || !showAbort)
    return null;

  return (
    <>
      
        <Button type="text" size="small" loading={isLoading} onClick={handleAction} startIcon={<AbortIcon/>}
          style={{color: "#E03923"}}>
            Abort
        </Button>
        
        <BasicModal
          handleClose={() => setOpenAbortModal(false)}
          action='Abort Campaign'
          loading={isLoading}
          handleAction={() => handleAbortCampaign()}
          open={openAbortModal}
          heading={"Aborting a campaign?"}
          headerIcon={<div style={{marginRight:"0.8rem"}}><AbortIcon height={"21.5"} width={"21.5"} /></div>}
          dimensions={{ height: 211, width: 360 }}
          content={
              <div style={{ fontWeight: "500px", paddingTop:"1.6rem" }}>This is an irreversible action. Aborting a campaign will permanently stop the campaign.</div>
            }
        /> 
    </>
  )
}
